module.exports = __webpack_public_path__ + "static/img/500.025f48c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/500.png
// module id = JE9E
// module chunks = 1